import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Box, CircularProgress, Container } from "@mui/material";
import Navbar from "../../Navbar";
import { getMenuesUsuario } from "./ApiServices";
import { MENU_CHEQUES, normalizarRutaMenu } from "./cheques.constants";
import { MENU_CHEQUES_RECHAZOS } from "./chequesRechazos.constants";
import { VISTA_ECHEQUE, leerParam, rutaEcheq } from "./echeqMenu.constants";
import ListadoChequesProveedores from "./ListadoChequesProveedores";
import ListadoChequesRechazos from "./ListadoChequesRechazos";

const accesoDesdeMenus = (lista) => {
  const rutas = new Set(
    (Array.isArray(lista) ? lista : []).map((m) => normalizarRutaMenu(m?.ruta))
  );
  return {
    cheques:
      rutas.has(MENU_CHEQUES.CC) ||
      rutas.has(MENU_CHEQUES.FINANZAS) ||
      rutas.has(MENU_CHEQUES.CARTERA),
    rechazos:
      rutas.has(MENU_CHEQUES_RECHAZOS.FINANZAS) ||
      rutas.has(MENU_CHEQUES_RECHAZOS.PAGOS) ||
      rutas.has(MENU_CHEQUES_RECHAZOS.JEFE) ||
      rutas.has(MENU_CHEQUES_RECHAZOS.CC),
  };
};

const vistaParaAcceso = (acceso, pedida) => {
  if (!acceso) return "";
  if (pedida === VISTA_ECHEQUE.CHEQUES && acceso.cheques) return pedida;
  if (pedida === VISTA_ECHEQUE.RECHAZOS && acceso.rechazos) return pedida;
  if (acceso.cheques) return VISTA_ECHEQUE.CHEQUES;
  if (acceso.rechazos) return VISTA_ECHEQUE.RECHAZOS;
  return "";
};

export default function PaginaEcheq() {
  const location = useLocation();
  const navigate = useNavigate();
  const [acceso, setAcceso] = useState(null);
  const vistaPedida = leerParam(location.search, "vista");
  const bandejaPedida = leerParam(location.search, "bandeja");
  const vista = vistaParaAcceso(acceso, vistaPedida);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        const lista = await getMenuesUsuario();
        if (!cancelado) setAcceso(accesoDesdeMenus(lista));
      } catch {
        if (!cancelado) setAcceso({ cheques: false, rechazos: false });
      }
    })();
    return () => {
      cancelado = true;
    };
  }, []);

  useEffect(() => {
    if (!acceso || !vista || vistaPedida === vista) return;
    navigate(
      rutaEcheq({ vista, bandeja: bandejaPedida || undefined }),
      { replace: true }
    );
  }, [acceso, vista, vistaPedida, bandejaPedida, navigate]);

  if (!acceso || (vista && vistaPedida !== vista)) {
    return (
      <>
        <Navbar />
        <Box display="flex" justifyContent="center" py={8}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (!vista) {
    return (
      <>
        <Navbar />
        <Container maxWidth="xl" sx={{ pt: "20px" }}>
          <Alert severity="info">No tenés bandejas de eCheq asignadas.</Alert>
        </Container>
      </>
    );
  }

  return vista === VISTA_ECHEQUE.RECHAZOS ? (
    <ListadoChequesRechazos />
  ) : (
    <ListadoChequesProveedores />
  );
}
